import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from 'components/Auth/Auth'

import Button from 'components/UI/Button'

const AuthFailedMessage = ({ message }) => {
    const auth = useContext(AuthContext)
    const { t } = useTranslation()

    return (
        <div className="auth-failed-message">
            <p>{message}</p>
            <div className="action-wrapper">
                <Button
                    className="button"
                    trackName="logout"
                    onClick={async () => {
                        await auth.actions.logout()
                    }}
                >
                    {t('common:close')}
                </Button>
            </div>
        </div>
    )
}

export default AuthFailedMessage
